import React from 'react';
import '../../../styles/parentPortal.css';

export default function EmptyState({ icon, title, description, action }) {
  return (
    <div
      className="pp-card"
      style={{
        border: '1px dashed var(--border-subtle)',
        // Placeholder state — flat, not lifted like a real card.
        boxShadow: 'none',
        padding: 'var(--space-7) var(--space-4)',
        textAlign: 'center',
      }}
    >
      {icon && (
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 'var(--radius-panel)',
            background: 'var(--bg-tertiary)',
            color: 'var(--text-secondary)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto var(--space-4)',
          }}
        >
          {icon}
        </div>
      )}
      <h2
        style={{
          margin: '0 0 var(--space-2)',
          fontSize: 'var(--text-section-size)',
          fontWeight: 'var(--text-section-weight)',
          color: 'var(--text-primary)',
        }}
      >
        {title}
      </h2>
      {description && (
        <p
          style={{
            margin: '0 auto var(--space-5)',
            color: 'var(--text-secondary)',
            fontSize: 'var(--text-body-size)',
            lineHeight: 1.5,
            maxWidth: 380,
          }}
        >
          {description}
        </p>
      )}
      {action}
    </div>
  );
}
